// extracted by mini-css-extract-plugin
module.exports = {"Home":"styles_Home__FPLDP"};